module.exports = __webpack_public_path__ + "static/71-038505c776b0f020d000a458c3d8d7c4.png";